import { render, staticRenderFns } from "./StudentStatusChkList.vue?vue&type=template&id=37e4acd5&"
import script from "./StudentStatusChkList.vue?vue&type=script&lang=js&"
export * from "./StudentStatusChkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports